import React from 'react';
import { Link } from 'react-router-dom';
import { resolveAsset } from '../api/client';
import { useT, useLocalField } from '../i18n';

export default function TemplateCard({ template }) {
  const t = useT();
  const lf = useLocalField();
  const minPrice = template.variants
    ?.filter(v => v.isActive)
    .reduce((min, v) => Math.min(min, v.priceCents), Infinity);
  const priceDisplay = minPrice < Infinity ? `${t.from} ${(minPrice / 100).toFixed(0)}${t.currency}` : '';
  // Catch-all "other" templates (fear-of-other, milestone-other, …) render as a
  // dashed "+" card — "mine isn't listed" — so we ignore any cover image and
  // show the "+" placeholder instead.
  const isOther = template.slug.endsWith('-other');

  return (
    <Link to={`/p/${template.slug}`} className={`template-card${isOther ? ' template-card-other' : ''}`}>
      <div className="template-card-image">
        {template.coverImageUrl && !isOther ? (
          <img src={resolveAsset(template.coverImageUrl)} alt={lf(template, 'nameAr')} />
        ) : (
          <div className="template-card-placeholder" />
        )}
      </div>
      <div className="template-card-body">
        <h3 className="template-card-title">{lf(template, 'nameAr')}</h3>
        {lf(template, 'taglineAr') && <p className="template-card-tagline">{lf(template, 'taglineAr')}</p>}
        <div className="template-card-meta">
          {template.ageBands?.length > 0 && (
            <span className="template-card-age">{template.ageBands.join(' / ')}</span>
          )}
          {priceDisplay && <span className="template-card-price">{priceDisplay}</span>}
        </div>
      </div>
    </Link>
  );
}
